import { defineMessages } from 'react-intl-next';

export const nativeEmbedToolbarMessages = defineMessages({
	alwaysShowTitle: {
		id: 'fabric.editor.alwaysShowTitle.non-final',
		defaultMessage: 'Always show title',
		description:
			'Label for the toggle to enable or disable the behaviour of always showing the title of the embed.',
	},
	refresh: {
		id: 'fabric.editor.refresh.non-final',
		defaultMessage: 'Refresh',
		description: 'Label for the button to refresh the embedded link.',
	},
	setEmbedType: {
		id: 'fabric.editor.setEmbedType.non-final',
		defaultMessage: 'Set embed type',
		description: 'Label for the button to set the type of embed.',
	},
});
